
import React from 'react';
import { EditedIcon, TranslateIcon } from '../../../../components/icons';
import createTime from '../utils/createTime';
import { MessageProps } from '../../MessageDisplayArea'

const MessageIndicators: React.FC<MessageProps> = ({
  message: { lastEditedTime, translatedTextHtml },
  common: { showTranslatedIndicator = false, texts },
}) => {
  const isShowEdited = !!lastEditedTime && lastEditedTime !== '0';
  const isShowTranslated = showTranslatedIndicator && !!translatedTextHtml;

  if (!isShowEdited && !isShowTranslated) return null;

  return (
    <p className="message-indicators">
      {isShowEdited && (
        <span className="last-edited-time">
          <EditedIcon />
          { createTime(lastEditedTime!) }
        </span>
      )}

      {isShowTranslated && (
        <span className="translate" title={texts ? texts['chat.message.tooltip.translated'] : ''}>
          <TranslateIcon />
        </span>
      )}
    </p>
  );
};

export default MessageIndicators
